import script from "./AdminHome.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminHome.vue?vue&type=script&setup=true&lang=js"

import "./AdminHome.vue?vue&type=style&index=0&id=20e70313&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20e70313"]])

export default __exports__